/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css, jsx } from '@compiled/react';

import { cssMap, cx } from '@atlaskit/css';
import { Box, Flex, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import type { CommonCardProps } from '../../../types';

const placeholderBackgroundColor = token('color.background.accent.gray.subtlest');

const legacyContainer = css({
	overflow: 'hidden',
	borderRadius: token('radius.large'),
	borderWidth: token('border.width'),
	borderColor: token('color.border'),
	borderStyle: 'solid',
	height: '100%',
});

const styles = cssMap({
	content: {
		height: '100%',
	},
	image: {
		minHeight: '0px',
		backgroundColor: placeholderBackgroundColor,
		flex: '1 1 0',
	},
	blockText: {
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
	},
	title: {
		width: '35px',
	},
	publishedDate: {
		width: '200px',
	},
	descriptionFirstLine: {
		width: '121px',
	},
	descriptionSecondLine: {
		width: '149px',
	},
	itemCommon: {
		height: '8px',
		backgroundColor: placeholderBackgroundColor,
	},
});

export const MediumPlaceholderCard = ({
	cardDimensions,
}: Pick<CommonCardProps, 'cardDimensions'>) => {
	const cardHeight = cardDimensions.height;

	const Content = () => (
		<Flex direction="column" xcss={styles.content}>
			<Box xcss={styles.image} />
			<Stack space="space.075" xcss={styles.blockText}>
				<Box xcss={cx(styles.title, styles.itemCommon)} />
				<Box xcss={cx(styles.publishedDate, styles.itemCommon)} />
				<Box xcss={cx(styles.descriptionFirstLine, styles.itemCommon)} />
				<Box xcss={cx(styles.descriptionSecondLine, styles.itemCommon)} />
			</Stack>
		</Flex>
	);

	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
		<div data-testId="medium-placeholder-card" css={legacyContainer} style={{ height: cardHeight }}>
			<Content />
		</div>
	);
};
